function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none",
  stroke: "none"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 19v.01"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15v-10"
});
const SvgExclamation = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon-tabler icon-tabler-exclamation-mark",
  fill: "none",
  height: 24,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  viewBox: "0 0 24 24",
  width: 24,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExclamation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exclamation.ce76ee7b.svg";
export { ForwardRef as ReactComponent };